import React, { useState, useEffect } from "react";
import { Layout, Menu, Drawer, Button, Grid, Affix, Alert, Form, Input, Modal } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { HeadersAuth } from "../funciones_utiles";
import { useNavigate, Link, useParams } from "react-router-dom";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import { manejarError } from "../manejo_errores";
import axios from "axios";

const { Header } = Layout;
const { useBreakpoint } = Grid;

export const NavbarInterna = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    setAlerta({ message: mensaje, type: tipo });
  };

  // Hook para detectar el tamaño de la pantalla
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { id_asociacion } = useParams();
  const [asociaciones, setAsociaciones] = useState([]);
  const [asociacionActiva, setAsociacionActiva] = useState(null);
  const [isDesvinculado, setIsDesvinculado] = useState(false);

  // Estado para controlar la visibilidad del modal de cambio de contraseña
  const [isModalVisible, setIsModalVisible] = useState(false);

  // Estado para almacenar los datos del formulario de cambio de contraseña
  const [form] = Form.useForm();

  // Función para abrir el modal
  const handleShowChangePasswordModal = () => {
    setIsModalVisible(true);
  };

  // Función para cerrar el modal
  const handleCancelChangePasswordModal = () => {
    setIsModalVisible(false);
    form.resetFields(); // Limpiar campos del formulario
  };

  // Función para enviar el formulario de cambio de contraseña
  const handleConfirmChangePassword = async () => {
    try {
      const values = await form.validateFields(); // Validar campos antes de enviar
      const { password_actual, nueva_password, confirmar_password } = values;

      if (nueva_password !== confirmar_password) {
        return manejarAlertas("error", "Las contraseñas no coinciden.");
      }

      if (nueva_password.length < 8) {
        return manejarAlertas("error", "La nueva contraseña debe tener al menos 8 caracteres.");
      }

      // Llamar al endpoint para cambiar la contraseña
      const response = await axios.put(
        `${process.env.REACT_APP_DOMINIO}/admin/reset-password`,
        { password_actual, nueva_password },
        HeadersAuth
      );

      if (response.status === 200) {
        manejarAlertas("success", "Contraseña actualizada correctamente.");
        setIsModalVisible(false); // Cerrar el modal después de una respuesta exitosa
        form.resetFields(); // Limpiar campos del formulario
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  // Verificar si el usuario ya está desvinculado al cargar el componente
  useEffect(() => {
    if (sesion.id_asociacion !== null) {
      setIsDesvinculado(true);
    }
  }, [sesion]);

  // Buscar asociaciones para traer la imagen
  useEffect(() => {
    fetchAsociaciones();
  }, [sesion.id_asociacion]);

  const fetchAsociaciones = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/asociaciones-publicas`);
      if (response.status === 200) {
        const asociacionesData = response.data;
        setAsociaciones(asociacionesData);
        if (asociacionesData) {
          const foundAsoc = asociacionesData.find((asoc) => asoc.id === sesion.id_asociacion);
          if (foundAsoc) {
            setAsociacionActiva(foundAsoc);
            return;
          }
        }
      }
    } catch (error) {
      console.error("Error al obtener asociaciones:", error);
      manejarAlertas("error", "Error al obtener asociaciones.");
    }
  };

  // Definir los elementos del menú dinámicamente
  const menuItems = [
    {
      key: "1",
      label: (
        <Link to="/admin">
          <BotonPrincipal texto="Inicio" style={{ width: "100%", textAlign: "center" }} />
        </Link>
      ),
    },
    {
      key: "4",
      label: (
        <BotonPrincipal
          texto="Cambiar Contraseña"
          onClick={handleShowChangePasswordModal}
          style={{ width: "100%", textAlign: "center" }}
        />
      ),
    },
    ...(!isDesvinculado
      ? []
      : [
          {
            key: "3",
            label: (
              <BotonPrincipal
                texto="Cambiar Asociación"
                onClick={(e) => desvincularAsoc(e)}
                style={{ width: "100%", textAlign: "center" }}
              />
            ),
          },
        ]),
    {
      key: "2",
      label: (
        <BotonPrincipal
          texto="Salir"
          onClick={(e) => logear(e)}
          style={{ width: "100%", textAlign: "center" }}
        />
      ),
    },
  ];
// Función para desvincular asociación
const desvincularAsoc = async (e) => {
  e.preventDefault();
  try {
    const desvincular = await axios.post(
      process.env.REACT_APP_DOMINIO + `/desvincular-asociacion`,
      {},
      {
        withCredentials: true,
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (desvincular.status === 200) {
      manejarAlertas("success", "Acción exitosa.");
      localStorage.setItem("administradoresSessionToken", desvincular.data.token);
      window.location.href = "/admin";
      setIsDesvinculado(true); // Actualizar estado para ocultar el botón
    }
  } catch (error) {
    manejarAlertas("error", manejarError(error));
  }
};

// Función para cerrar sesión
const logear = async (e) => {
  e.preventDefault();
  localStorage.removeItem("administradoresSessionToken");
  navigate("/login");
};
  return (
    <>
      <Affix offsetTop={0}>
        <Header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 20px",
            height: "64px",
          }}
        >
          <div
            className="logo"
            style={{
              flex: "0 0 200px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={
                asociacionActiva?.imagen
                  ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${asociacionActiva.id}/IMAGENES/ASOCIACIONES/${asociacionActiva.imagen}`
                  : "/img/logo-mundo-piloto.svg"
              }
              alt="Logo"
              style={{ maxWidth: "50%", height: "64px", objectFit: "contain" }}
            />
          </div>
          <div
            style={{
              flex: "1",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              overflow: "hidden",
              gap: "10px",
            }}
          >
            {screens.md ? (
              <Menu
                theme="dark"
                mode="horizontal"
                items={menuItems}
                style={{
                  lineHeight: "64px",
                  fontSize: "14px",
                  padding: "0 10px",
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              />
            ) : (
              <>
                <Button
                  type="text"
                  icon={<MenuOutlined style={{ color: "white", fontSize: "20px" }} />}
                  onClick={() => setDrawerVisible(true)}
                />
                <Drawer
                  title="Menú"
                  placement="right"
                  onClose={() => setDrawerVisible(false)}
                  visible={drawerVisible}
                >
                  <Menu mode="vertical" items={menuItems} />
                </Drawer>
              </>
            )}
          </div>
        </Header>
      </Affix>

      {/* Modal para cambiar contraseña */}
      <Modal
        title="Cambiar contraseña"
        visible={isModalVisible}
        onCancel={handleCancelChangePasswordModal}
        footer={null} // Eliminar el pie de página predeterminado
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleConfirmChangePassword}
          style={{ marginTop: "20px" }}
        >
          <Form.Item
            name="password_actual"
            label="Contraseña actual"
            className="custom-form-item"
            rules={[
              { required: true, message: "Por favor ingresa tu contraseña actual." },
            ]}
          >
            <Input.Password className="password-admin" placeholder="Ingresa tu contraseña actual" />
          </Form.Item>

          <Form.Item
            name="nueva_password"
                className="custom-form-item"
            label="Nueva contraseña"
            rules={[
              { required: true, message: "Por favor ingresa tu nueva contraseña." },
              { min: 8, message: "La nueva contraseña debe tener al menos 8 caracteres." },
            ]}
          >
            <Input.Password className="password-admin" placeholder="Ingresa tu nueva contraseña" />
          </Form.Item>

          <Form.Item
            name="confirmar_password"
                className="custom-form-item"
            label="Confirmar nueva contraseña"
            dependencies={["nueva_password"]}
            rules={[
              { required: true, message: "Por favor confirma tu nueva contraseña." },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("nueva_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Las contraseñas no coinciden."));
                },
              }),
            ]}
          >
            <Input.Password className="password-admin" placeholder="Confirma tu nueva contraseña" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block style={{fontSize:"1em", width:"auto"}}>
              Confirmar Cambio
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};